import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Plane, Shirt, Car, TrendingUp, Bitcoin, Laptop, Home, UtensilsCrossed, Sparkles, Gamepad2, HeartPulse, BookOpen } from "lucide-react";

const ICONS = { travel: Plane, clothing: Shirt, auto: Car, stocks: TrendingUp, crypto: Bitcoin, electronics: Laptop, home: Home, food: UtensilsCrossed, beauty: Sparkles, gaming: Gamepad2, health: HeartPulse, books: BookOpen };

export default function CategoriesPage() {
  const [cats, setCats] = useState([]);
  const [counts, setCounts] = useState({});

  useEffect(() => {
    (async () => {
      const [c, d] = await Promise.all([api.get("/deals/categories"), api.get("/deals")]);
      setCats(c.data);
      const map = {};
      d.data.forEach((deal) => { map[deal.category] = (map[deal.category] || 0) + 1; });
      setCounts(map);
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-12" data-testid="categories-page">
      <div className="mb-10">
        <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#E63946] mb-3">All Sections</div>
        <h1 className="font-serif font-black text-5xl md:text-6xl tracking-tighter">
          Ten categories,<br />one directory.
        </h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {cats.map((c) => {
          const Icon = ICONS[c.slug] || Plane;
          return (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group border border-black/10 p-8 hover:bg-black hover:text-white flex items-center gap-6"
              data-testid={`cat-link-${c.slug}`}
            >
              <Icon className="w-10 h-10 group-hover:text-[#E63946]" strokeWidth={1.5} />
              <div className="flex-1">
                <div className="font-serif font-bold text-2xl tracking-tight">{c.name}</div>
                <div className="text-xs font-mono uppercase tracking-widest text-black/50 group-hover:text-white/60 mt-1">
                  {counts[c.slug] || 0} deals
                </div>
              </div>
              <span className="font-serif text-2xl group-hover:text-[#E63946]">→</span>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
